export var StatusDelivery;
(function (StatusDelivery) {
    StatusDelivery["ORDER"] = "ORDER";
    StatusDelivery["LOCATION"] = "LOCATION";
    StatusDelivery["SUMMARY"] = "SUMMARY";
    StatusDelivery["REDIRECTED"] = "REDIRECTED";
    StatusDelivery["FINISHED"] = "FINISHED";
})(StatusDelivery || (StatusDelivery = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CARD"] = "CARD";
    PaymentMethod["CASH"] = "CASH";
    PaymentMethod["TRANSFER"] = "TRANSFER";
    PaymentMethod["ONLINE"] = "ONLINE";
})(PaymentMethod || (PaymentMethod = {}));
export default class Order {
    constructor(restaurantId = '') {
        this.id = "";
        this.menuId = '';
        this.items = [];
        this.name = '';
        this.userId = '';
        this.sent = false;
        this.subtotal = 0;
        this.total = 0;
        this.deliveryCost = 0;
        this.type = '';
        this.status = '';
        this.currency = '';
        this.number = '';
        this.createdAt = '';
        this.udpatedAt = '';
        this.payment = PaymentMethod.CASH;
        this.paymentDetails = undefined;
        this.cash = '';
        this.location = '';
        this.phone = '';
        this.phoneExt = '';
        this.email = '';
        this.address = undefined;
        this.statusDelivery = StatusDelivery.ORDER;
        this.restaurantId = restaurantId;
    }
}
